<template>
    <Dialog :dialog="dlg">
        <template v-slot:content>
        <v-card-text class="content pa-4">

        <v-form ref="form" lazy-validation>
            <Form>
                <FormRow label="Medewerker">            
                    <EmployeeCombo :rules="model.rules.mandatory" :model="model" v-model="model.id_employee"></EmployeeCombo>
                </FormRow>
                <FormRow label="Datum">            
                    <v-row dense>
                        <v-col>
                            <DatePicker :model="model" v-model='model.dt' :rules="model.rules.mandatory"></DatePicker>
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>
                </FormRow>
                <FormRow label="Van/tot">            
                    <v-row dense>
                        <v-col>
                            <v-row dense>
                                <v-col>
                                    <TimeField hm block dusk="from" v-model='model.from' :model='model' :rules="model.rules.mandatory"></TimeField>
                                </v-col>
                                <v-col>
                                    <TimeField hm block dusk="to" v-model='model.to' :model='model' :rules="model.rules.mandatory"></TimeField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col></v-col>
                    </v-row>
                </FormRow>
             </Form>
        </v-form>    
        </v-card-text>

        </template>

    </Dialog>
</template>



<script setup>
    import useModel from '@/features/workorders/workorder/model/appointmentedit'
    import Form from '@controls/forms/Form'
    import FormRow from '@controls/forms/FormRow'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import { ref, computed } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import EmployeeCombo from '@controls/combo/Employee'
    import DatePicker from '@controls/input/DatePicker'
    import TimeField from '@controls/input/TimeField'
    import TextField from '@controls/input/TextField'
    const form = ref(null);

    let model = useModel();
    let dlg = ref(
        new clsDialog("workorder_appointment", "Wijzig afspraak", model, [form], {
            showNote: false,
            showAttachment: false,
            icon: 'calendar',
            noSubTitle: true,
//            save: 'Opslaan',
//            closeAfterSave: false
        } )).value;

</script>
